import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

const useAuthStore = create(
    devtools(
        persist((set) => ({
            isAuthenticated: false,
            refresh_token: '',
            nextRefreshTime: null,
            roles: [],
            logIn: (params) => set((state) => ({ ...state, isAuthenticated: true, ...params })),
            logOut: () => set({ isAuthenticated: false }),
        }), {
            name: 'auth-storage'
        }
        )
    )
)

export {
    useAuthStore
}